module.exports = __webpack_public_path__ + "assets/webgl/worms.3f1dc32f.jpg";